import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { PrivacyPolicy } from 'views/privacy-policy'

const PrivacyPolicyPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'privacypolicy.meta.title' })}
        description={formatMessage({ id: 'privacypolicy.meta.description' })}
      />
      <Header />
      <PrivacyPolicy />
      <Footer />
    </>
  )
}

export default PrivacyPolicyPage
